import React, { Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Navbar, Sidebar, Footer, Toast, ErrorBoundary, WhatsAppButton, Loading } from './components';
import { useProductsContext } from './context/products_context';
import 'react-toastify/dist/ReactToastify.css';
import {
  Home,
  About,
  Products,
  Cart,
  SingleProduct,
  Checkout,

  Error,
  Login,
  Register,
  Forgot,
  Reset,
  OrdersPage,
  PrivateRoute,
  ProfilePage,
  FAQPage,
  ShippingPage,
  ReturnsPage,
  TrackOrderPage,
  OurStoryPage,
  ContactPage,
  OffersPage,
  WishlistPage,
} from './pages';

import PageViewTracker from './components/PageViewTracker';

function App() {
  const { isSidebarOpen } = useProductsContext();
  const overflowPropertyToHideScroll =
    isSidebarOpen === true ? 'hidden' : 'visible';

  return (
    <div style={{ overflow: overflowPropertyToHideScroll }}>
      <Router>
        <PageViewTracker />
        <Toast />
        <Navbar />
        <Sidebar />
        <ErrorBoundary>
          <main style={{ paddingTop: '0' }}>
            <Suspense fallback={<Loading />}>
              <Switch>
                <Route exact path='/'>
                  <Home />
                </Route>
                <Route exact path='/about'>
                  <About />
                </Route>
                <Route exact path='/products'>
                  <Products />
                </Route>
                <Route exact path='/cart'>
                  <Cart />
                </Route>
                <PrivateRoute exact path='/login'>
                  <Login />
                </PrivateRoute>
                <PrivateRoute exact path='/register'>
                  <Register />
                </PrivateRoute>
                <PrivateRoute exact path='/forgot-password'>
                  <Forgot />
                </PrivateRoute>
                <PrivateRoute exact path='/reset-password'>
                  <Reset />
                </PrivateRoute>
                <Route exact path='/products/:id' children={<SingleProduct />} />
                <Route exact path='/checkout'>
                  <Checkout />
                </Route>
                <PrivateRoute exact path='/orders'>
                  <OrdersPage />
                </PrivateRoute>
                <PrivateRoute exact path='/profile'>
                  <ProfilePage />
                </PrivateRoute>
                <Route exact path='/faq'>
                  <FAQPage />
                </Route>
                <Route exact path='/shipping'>
                  <ShippingPage />
                </Route>
                <Route exact path='/returns'>
                  <ReturnsPage />
                </Route>
                <Route exact path='/track-order'>
                  <TrackOrderPage />
                </Route>
                <Route exact path='/our-story'>
                  <OurStoryPage />
                </Route>
                <Route exact path='/contact'>
                  <ContactPage />
                </Route>
                <Route exact path='/offers'>
                  <OffersPage />
                </Route>
                <Route exact path='/wishlist'>
                  <WishlistPage />
                </Route>
                <Route exact path='*'>
                  <Error />
                </Route>
              </Switch>
            </Suspense>
          </main>
        </ErrorBoundary>
        <Footer />
        <WhatsAppButton />
      </Router>
    </div>
  );
}

export default App;
